import React from "react"
import { Link } from "gatsby"

import Pill from "~components/Pill"
import Resources from "./Resources"
import Endpoints from "./Endpoints"
import DeprecatedItems from "./DeprecatedItems"

import * as style from "./List.module.scss"

const List = ({
  list, hideHeaders = false, sortByKey = false, microcopy,
}) => {
  const firstItem = list.resources?.[0] || list.endpoints?.[0]

  return (
    <div className={style.block}>
      <header>
        {firstItem?.path ? (
          <Link to={firstItem.path} className={style.link} data-pill={list.isBeta}>
            <span>{list.withVersion ? `${list.name} v${list.version}` : list.name}</span>
            { list.isBeta && (
            <Pill
              pillType="pillSmall"
              text={microcopy.text("reference.pill.beta")}
              color="blue"
              className={style.tagPill}
            />
            )}
          </Link>
        ) : (
          <span>{list.name}</span>
        )}
      </header>

      <div className={style.content}>
        <Resources resources={list.resources} hideHeaders={hideHeaders} sortByKey={sortByKey} />
        <Endpoints endpoints={list.endpoints} hideHeaders={hideHeaders} sortByKey={sortByKey} />
        <DeprecatedItems deprecatedItems={list.deprecatedItems} />
      </div>
    </div>
  )
}

export default List
